import React from 'react';
import { Section } from '../..';
import { defaultPropTypes } from '../AdditionalData';
import { checkSectionCondition } from '../../../Form.helpers';

const Availability = ({ field, translations }) => {
    const renderedSection = checkSectionCondition(field.textAnswer);

    return (
        <Section.Conditional
            condition={renderedSection}
            title={translations.availability}
        >
            {({ renderField }) => (
                renderField(translations.availabilityLabel, field.textAnswer)
            )}
        </Section.Conditional>

    );
};
Availability.propTypes = defaultPropTypes;
export default Availability;